module.exports = __webpack_public_path__ + "static/media/incident_category-aviation.582946f5.svg";